import { StyledTable } from '@/Components/Elements/StyledComponents/Tables'
import React, { Component } from 'react'
import {
    Box,
    Grid,
    Paper,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/pro-duotone-svg-icons/faInfoCircle'
import logo from '../../../images/xlab-logo.jpg'
import Loading from '@/Components/Elements/Loading/LoadingData'
import AppDialog from '@/Components/AppDialog/AppDialog'
import {
    StyledButton,
    CompactButton,
} from '@/Components/Elements/StyledComponents/Buttons'

class EnvironmentDetails extends Component {
    constructor(props) {
        super(props)

        this.state = {
            EditEnvironmentForm: false,
            description: null,
            details: [],
            detailsLoaded: false,
            errorFields: {},
            errors: false,
            file: '',
            imagePreviewUrl: '',
            name: null,
            saving: false,
        }

        this.handleClose = this.handleClose.bind(this)
    }

    fetchDetails() {
        this.setState({ loading: true })
        this.props.kedo
            .api()
            .get(
                this.props.kedo.api().getEnvironmentEndpoint() +
                    '/' +
                    this.props.item.id
            )
            .then((response) => {
                this.setState({
                    details: response.data,
                    loading: false,
                })
            })
    }

    handleClose(openEnvironment) {
        this.setState({ EditEnvironmentForm: false })
        if (openEnvironment) {
            this.props.environment()
        }
    }

    getLogo(item) {
        if (!item.logo || !item.logo.base64) {
            return <img className={'avatar'} src={logo} alt={'Logo'} />
        }

        return (
            <img
                className={'avatar'}
                src={`data:image/jpeg;base64,${item.logo.base64}`}
                alt={'Logo ' + item.name}
            />
        )
    }

    environmentDetails() {
        const kedo = this.props.kedo

        return (
            <AppDialog
                aria-labelledby="contained-modal-title-vcenter"
                open
                maxWidth={'md'}
                fullWidth
                title={this.state.details.name}
                onClose={this.handleClose}
                headerClose={this.handleClose}
                contentProps={{ dividers: true }}
                actions={
                    <>
                        <StyledButton onClick={() => this.handleClose(true)}>
                            {kedo.t('Open environment')}
                        </StyledButton>
                        <StyledButton
                            onClick={() => this.handleClose(false)}
                            color="secondary"
                            title={'Cancel'}
                        >
                            {kedo.t('Close')}
                        </StyledButton>
                    </>
                }
            >
                <Box>
                    {this.state.loading ? (
                        <Loading />
                    ) : (
                        <Grid container>
                            <Grid size={4}>
                                {this.getLogo(this.state.details)}
                            </Grid>
                            <Grid size={8} className="table-responsive">
                                <TableContainer component={Paper}>
                                    <StyledTable striped size="small">
                                        <TableBody sx={{}}>
                                            <TableRow>
                                                <TableCell
                                                    sx={{ fontWeight: 'bold' }}
                                                >
                                                    {kedo.t('Name')}
                                                </TableCell>
                                                <TableCell>
                                                    {this.state.details.name
                                                        ? this.state.details
                                                              .name
                                                        : kedo.t('Unknown')}
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell
                                                    sx={{ fontWeight: 'bold' }}
                                                >
                                                    {kedo.t('Description')}
                                                </TableCell>
                                                <TableCell>
                                                    {this.state.details
                                                        .description
                                                        ? this.state.details
                                                              .description
                                                        : kedo.t('Unknown')}
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell
                                                    sx={{ fontWeight: 'bold' }}
                                                >
                                                    {kedo.t('Created by')}
                                                </TableCell>
                                                <TableCell>
                                                    {this.state.details
                                                        .created_by &&
                                                    this.state.details
                                                        .created_by.username
                                                        ? this.state.details
                                                              .created_by
                                                              .username
                                                        : kedo.t('Unknown')}
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell
                                                    sx={{ fontWeight: 'bold' }}
                                                >
                                                    {kedo.t('Created at')}
                                                </TableCell>
                                                <TableCell>
                                                    {kedo
                                                        .utils()
                                                        .dateFormat(
                                                            this.state.details
                                                                .created_at
                                                        )}
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell
                                                    sx={{ fontWeight: 'bold' }}
                                                >
                                                    {kedo.t('Last modified on')}
                                                </TableCell>
                                                <TableCell>
                                                    {this.state.details
                                                        .modified_at
                                                        ? kedo
                                                              .utils()
                                                              .dateFormat(
                                                                  this.state
                                                                      .details
                                                                      .modified_at
                                                              )
                                                        : kedo.t(
                                                              'Unknown'
                                                          )}{' '}
                                                    (
                                                    {this.state.details
                                                        .modified_by &&
                                                    this.state.details
                                                        .modified_by.username
                                                        ? this.state.details
                                                              .modified_by
                                                              .username
                                                        : kedo.t('Unknown')}
                                                    )
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </StyledTable>
                                </TableContainer>
                            </Grid>
                        </Grid>
                    )}
                </Box>
            </AppDialog>
        )
    }

    render() {
        return (
            <>
                {this.state.EditEnvironmentForm
                    ? this.environmentDetails()
                    : null}
                <CompactButton
                    disabled={!this.props.item.active}
                    sx={{ float: 'right' }}
                    onClick={() => {
                        this.fetchDetails()
                        this.setState({ EditEnvironmentForm: true })
                    }}
                    aria-label={`Environment information for ${this.props.item.name}`}
                    color="secondary"
                >
                    <FontAwesomeIcon icon={faInfoCircle} />
                </CompactButton>
            </>
        )
    }
}

export default EnvironmentDetails
